import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function generateSlug(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "") // Remove special characters
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-") // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, "") // Remove leading/trailing hyphens
    .slice(0, 50) // Max 50 characters
}

export function isValidSlug(slug: string): boolean {
  if (!slug || slug.length < 3 || slug.length > 50) return false
  // Only lowercase letters, numbers, and hyphens
  if (!/^[a-z0-9-]+$/.test(slug)) return false
  // No consecutive hyphens
  if (/--/.test(slug)) return false
  // Can't start or end with hyphen
  if (slug.startsWith("-") || slug.endsWith("-")) return false
  return true
}

export const RESERVED_SLUGS = [
  "admin",
  "api",
  "auth",
  "dashboard",
  "listings",
  "login",
  "signup",
  "settings",
  "blog",
  "pricing",
  "terms",
  "privacy",
  "invite",
  "shop",
  "traction",
  "articles",
  "setup",
  "robots",
  "sitemap",
  "error",
]
